<template>
    <div class="row">
        <div class="form-group col-sm-7">
            <label>{{ selectLabel }} :</label>
            <v-select @search="fetchOptions" label="fullName" :options="customersList" :selectOnTab="true" id="customervSelect" v-model="customer">
                <div slot="no-options">{{ vselectErrors }}</div>
            </v-select>
        </div>
        <div class="col-sm-5">
            <button type="button" class="btn btn-right blue btn-block btn-inline" @click="toggleModal">{{ btnLabel }}</button>
        </div>
        <customer-modal :show="showModal" v-model="customer"></customer-modal>
        <input v-if="customer" type="hidden" name="customerId" class="form-control" :value="customer.id"/>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'customerSelect',
  $_veeValidate: {
    name() {
      return this.selectLabel;
    },
    value() {
      return this.customer;
    }
  },
  components: { 'v-select': vSelect },
  props: {
    selectLabel: {
      type: String,
      default:"Choisir un client existant *"
    },
    btnLabel: {
      type: String,
      default:"Nouveau client"
    },
    value: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      customer : this.value,
      customersList: [],
      vselectErrors: 'Tapez au moins 3 lettres pour rechercher un client',
      showModal: false,
      requestController: null
    }
  },
  watch: {
    customer: function(val) { // if customer change : emit input to update parent v-model
      this.$emit('input',val);
    },
    value: function(val) { // if v-model parent change, update customer
      this.customer = val;
    }
  },
  methods: {
    async fetchOptions(search, loading, minLength = 3) {
      this.requestController?.abort()
      this.requestController = new AbortController();

      if(search.length >= minLength)
      {
        loading(true)
        axios.get('/customer/get/' + search, { signal: this.requestController.signal })
          .then(res => {
            this.customersList = Object.values(res.data)
            if(!res.data.length) {
              this.customer = {}
            }
            $('#customervSelect').prop("aria-expanded","true")
            loading(false)
          })
          .catch(error => {
            if (error.__CANCEL__) return;

            this.customersList = [];
            console.error(error)
            loading(false)
          })
        this.vselectErrors = 'Pas de clients correspondants'
      } else {
        this.customersList = []
        this.vselectErrors = 'Tapez au moins 3 lettres pour rechercher un client'
      }
    },
    toggleModal() {
      this.showModal = !this.showModal
    },
  }
}
</script>

<style scoped>
.content {
  display: flex;
  justify-content: space-around;
}
.btn-inline{
  margin-top: 2.5rem;
}
</style>
